import { useTranslation } from 'react-i18next';

const BrandsSection = ({ lang, marcas, ruta }) => {

    const { t } = useTranslation();
    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <app-brands _ngcontent-ng-c2915285710="">
            <div className="c-bg-brands">
                <div className="container">
                    <h3 className="text-center">
                        <span className="text-rewards">{t("RECOMPENSAS EXCLUSIVAS")}</span> {t("EN TODOS NUESTROS ALOJAMIENTOS")}
                    </h3>
                    <div className="c-brands">
                        {marcas.map((unamarca, index) => (
                            <a rel="nofollow" target="_blank" className="c-brands-item" href="#" key={index}>
                                <figure className="c-brands-figure brand-h10">
                                    {unamarca.imagen_cabecera ?
                                        <img alt="" className="c-brands-img" src={`${ruta}/marcas/${unamarca.id}/logo/${unamarca.imagen_cabecera}`} />
                                        :
                                        <img alt="" className="c-brands-img" src="/images/web/bedloop-nofoto.png" />
                                    }
                                </figure>
                                <p dangerouslySetInnerHTML={{ __html: unamarca.descripcion_corta[lang] }}></p>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </app-brands>
    )
}
export default BrandsSection;
